




















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { QuoteApi } from '@/api/quote-api';
import { EnquiryProduct } from '@/models/enquiry-product';
import { EnquiryApi } from '@/api/enquiry-api';
import { Enquiry } from '@/models/enquiry';
import { QuoteProduct } from '@/models/quote-product';
import { Quote } from '@/models/quote';
import { QuoteHistory } from '@/models/quote-history';
import { namespace } from 'vuex-class';
import quoteStatusLabel from '@/components/quote-status-label.vue';
import quoteHistoryDescription from '@/components/quote-history-description.vue';
import { Permissions } from '@/models/permission-constants';

const quoteApi = new QuoteApi();

@Component({
    components: {
        quoteStatusLabel,
        quoteHistoryDescription,
    },
})
export default class QuoteQuickViewModal extends Vue {
    @Prop({ required: true, type: Boolean }) public show: boolean;
    @Prop({ required: true }) public quoteId: string;
    public showing: boolean = this.show;
    public quote: Quote | null = null;
    public history: Array<QuoteHistory> = [];
    public products: Array<QuoteProduct> = [];

    private async mounted(): Promise<void> {
        const quote = await quoteApi.fetchByIdAsync(this.quoteId);
        const history = await quoteApi.fetchHistoryByIdAsync(this.quoteId);
        this.quote = quote;
        this.products = this.quote.products;
        this.history = history;
    }

    public reset(): void {
        this.quote = null;
    }

    public toggleShow(): void {
        if (this.showing) {
            this.$emit('quote-quick-view-show');
        } else {
            this.$emit('quote-quick-view-hide');
        }
    }

    @Watch('show')
    public toggle(value: boolean): void {
        this.reset();
        this.showing = value;
    }
}
